import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "row justify-start q-mb-lg" };
const _hoisted_3 = {
    key: 0,
    class: "hason-contents"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "q-pa-sm items-start" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "q-mt-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_toggle = _resolveComponent("q-toggle");
    const _component_q_checkbox = _resolveComponent("q-checkbox");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_field = _resolveComponent("q-field");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_input = _resolveComponent("q-input");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_toggle, {
                class: "text-h6 text-weight-bold",
                disable: _ctx.readonly,
                color: "green",
                "keep-color": "",
                modelValue: _ctx.hasonInfo.isNothing,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.hasonInfo.isNothing) = $event)),
                label: "故意過失による破損・汚損はありません。",
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.changeNothing(_ctx.hasonInfo)))
            }, null, 8, ["disable", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hasonInfo.hasonList, (hason) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: hason.hanyoCd,
                    class: "hason-card q-pa-md"
                }, [
                    _createVNode(_component_q_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_card_section, { class: "bg-white text-left" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_checkbox, {
                                        class: "text-h5 text-bold text-green-7",
                                        modelValue: hason.isSelected,
                                        "onUpdate:modelValue": ($event) => ((hason.isSelected) = $event),
                                        label: hason.target,
                                        color: "green-7",
                                        disable: _ctx.hasonInfo.isNothing || _ctx.readonly,
                                        onClick: ($event) => (_ctx.changeSelected(hason)),
                                        ref_for: true,
                                        ref: "checkbox"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disable", "onClick"])
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(_component_q_separator),
                            _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                    (hason.status || hason.detail)
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                                            _createElementVNode("tbody", null, [
                                                (hason.status)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                                                        _cache[3] || (_cache[3] = _createElementVNode("th", null, "■状況", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(hason.status), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (hason.detail)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                                        _cache[4] || (_cache[4] = _createElementVNode("th", null, "■修繕内容", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(hason.detail), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (hason.kingaku)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                                                        _cache[5] || (_cache[5] = _createElementVNode("th", null, "■金額（税別）", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(hason.kingaku), 1)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                    (_ctx.hasonInfo.sKeiyakuKb === 0)
                                        ? (_openBlock(), _createBlock(_component_q_field, {
                                            key: 0,
                                            outlined: "",
                                            color: "positive",
                                            "no-error-icon": "",
                                            error: _ctx.valid.hasCardError(hason),
                                            "error-message": _ctx.valid.hasCardError(hason) ? _ctx.requiredCheckBoxErrorMessage : ''
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_7, [
                                                    _createElementVNode("div", _hoisted_8, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hason.checkedArray, (check, index) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: index,
                                                                class: "col-4 q-pa-xs"
                                                            }, [
                                                                _createVNode(_component_q_btn, {
                                                                    class: "toggle-button",
                                                                    disable: !hason.isSelected || _ctx.readonly,
                                                                    label: check.name,
                                                                    color: hason.isSelected && check.isChecked ? 'green-7' : 'light-green-3',
                                                                    onClick: ($event) => (check.isChecked = !check.isChecked)
                                                                }, null, 8, ["disable", "label", "color", "onClick"])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ]),
                                            _: 2
                                        }, 1032, ["error", "error-message"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1024)
                        ]),
                        _: 2
                    }, 1024)
                ]));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-weight-bold text-h6" }, "※上記表に記載が無い品目等の場合は、以下に箇所・状況をご記入してください。", -1)),
            _createVNode(_component_q_input, {
                modelValue: _ctx.hasonInfo.remarks,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.hasonInfo.remarks) = $event)),
                label: "記入スペース",
                filled: "",
                type: "textarea",
                readonly: _ctx.hasonInfo.isNothing || _ctx.readonly,
                error: _ctx.valid.remarks.error,
                "error-message": _ctx.valid.remarks.message
            }, null, 8, ["modelValue", "readonly", "error", "error-message"])
        ])
    ], 64));
}
